module.exports = __webpack_public_path__ + "img/stt-dex.4e6b6359.svg";